import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 15,
	viewBox: "0 0 26 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0156 8.16651C20.0346 8.16574 21.0396 8.40261 21.951 8.85829C22.8623 9.31397 23.6549 9.9759 24.2656 10.7915",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.29688 10.7915C1.90762 9.9759 2.70016 9.31397 3.61152 8.85829C4.52287 8.40261 5.52794 8.16574 6.54688 8.16651",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 11.6665C14.3289 11.6665 15.4062 10.5892 15.4062 9.26025C15.4062 7.93132 14.3289 6.854 13 6.854C11.6711 6.854 10.5938 7.93132 10.5938 9.26025C10.5938 10.5892 11.6711 11.6665 13 11.6665Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.60938 13.5259C9.95148 12.9596 10.4392 12.4902 11.0242 12.1641C11.6093 11.838 12.2715 11.6665 12.9453 11.6665C13.6192 11.6665 14.2813 11.838 14.8664 12.1641C15.4515 12.4902 15.9391 12.9596 16.2812 13.5259",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.625 3.7915C15.7886 3.15775 16.1267 2.58257 16.6008 2.1313C17.0749 1.68004 17.6661 1.37076 18.3072 1.2386C18.9482 1.10643 19.6135 1.15668 20.2274 1.38363C20.8414 1.61058 21.3794 2.00514 21.7803 2.5225C22.1813 3.03986 22.4291 3.65929 22.4957 4.31044C22.5623 4.96159 22.445 5.61836 22.157 6.20617C21.8691 6.79398 21.4221 7.28926 20.8668 7.63579C20.3115 7.98231 19.6702 8.16617 19.0156 8.1665",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.54511 8.1665C5.89057 8.16617 5.24923 7.98231 4.69394 7.63579C4.13865 7.28926 3.69165 6.79398 3.40372 6.20617C3.11578 5.61836 2.99845 4.96159 3.06504 4.31044C3.13162 3.65929 3.37947 3.03986 3.78042 2.5225C4.18138 2.00514 4.71937 1.61058 5.33331 1.38363C5.94725 1.15668 6.61253 1.10643 7.25359 1.2386C7.89465 1.37076 8.4858 1.68004 8.95992 2.1313C9.43403 2.58257 9.7721 3.15775 9.93574 3.7915",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgUsers as ReactComponent };
